import {initIbanEditPartial} from "./ibanEditPartial";
import {initNotarySearch} from "./notarySearch";

// TODO perhaps rename this to prevent ambigious reference to document page
export function initDocumentsPage(){
    initIbanEditPartial();
    initNotarySearch();
    document.addEventListener('sds-upload:file-added', handleFileAdded);
    
}

function handleFileAdded(e){
    const src = e.srcElement;
    const accordionItem = src.closest('details.accordion-item');
    if (accordionItem) {
        accordionItem.removeAttribute('open');
    }
}